import { cn } from '@/lib/utils'

interface IScrollableContainerProps {
  children: React.ReactNode
  gap?: string
  className?: string
}

export function ScrollableContainer({
  children,
  gap = 'gap-20',
  className
}: IScrollableContainerProps) {
  return (
    <div
      className={cn(
        'mx-auto flex w-full max-w-[1280px] flex-col',
        gap,
        className
      )}
    >
      {children}
    </div>
  )
}
